<div *ngIf="visible" class="modal-background">
  <div [@dialog] *ngIf="_upsell && toSiteAdvert" class="modal-body">
    <div class="modal-body-flex">
      <div class="left">
        <h2>Want to reach {{toSiteAdvert.expectedReach}} more readers for only ${{getHeaderPaymentAmount}}?</h2>
        <div class="description" *ngIf="_upsell.additionalUpsellCopy" [innerHtml]="_upsell.additionalUpsellCopy"></div>
        <div class="summary-cost">
          A <strong>{{toSiteAdvert.name}}</strong> promotion from <strong>{{toSiteAdvert._site.name}}</strong> will be added to your cart.
          Your new total will be
          <strong>${{getTotalPaymentAmount}}</strong>.
        </div>
        <div class="footer">
          <button class="button green" (click)="onAcceptUpsell()">Yes, add the promotion to my cart</button>
          <button class="button outline" (click)="onClose()">No Thanks</button>
        </div>
      </div>
      <div class="right">
        <img src="{{_featureImage}}">
      </div>
    </div>
    <div class="upsell-discount" *ngIf="applyingDiscount">*Price reflects member discount. Price may vary based on discount availability</div>
    <div class="close" (click)="onClose()">X</div>
  </div>
</div>
